<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('account.addAccount') }}
      </div>
    </div>
    <div class="wrap_box warp1">
      <div class="item">
        <div class="ari_font">
          {{ $t('account.bank') }}：
        </div>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="value"
            :options="wallets"
            @change="onChange()"
          />
        </van-dropdown-menu>
      </div>
      <!-- 虚拟货币 -->
      <div v-show="bank.type == 1">
        <div class="item">
          <div class="ari_font">
            {{ $t('account.address') }}：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            :placeholder="$t('account.addressTit')"
          >
        </div>
        <!-- <div class="qrcode">
          <div>{{$t('account.qrcodetips')}}</div>
          <div class="qrcode_img">
            <van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead"
              :before-read="beforeRead">
            </van-uploader>
          </div>
        </div> -->
      </div>
      <!-- 支付宝 -->
      <div v-show="bank.type == 2">
        <div class="item">
          <div class="ari_font">
            支付宝账号：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            placeholder="请输入支付宝账号"
          >
        </div>
        <div class="qrcode">
          <div>支付宝收款码</div>
          <div class="qrcode_img">
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="1"
              class="upload"
              :max-size="2 * 1024 * 1024"
              :after-read="afterRead"
              :before-read="beforeRead"
              @oversize="onOversize"
            />
          </div>
        </div>
      </div>
      <!-- 微信 -->
      <div v-show="bank.type == 3">
        <div class="item">
          <div class="ari_font">
            微信号 ：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            placeholder="请输入微信号"
          >
        </div>
        <div class="qrcode">
          <div>微信收款码</div>
          <div class="qrcode_img">
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="1"
              class="upload"
              :max-size="2 * 1024 * 1024"
              :after-read="afterRead"
              :before-read="beforeRead"
              @oversize="onOversize"
            />
          </div>
        </div>
      </div>
      <!-- 银行卡 -->
      <div v-show="bank.type == 4">
        <template v-if="isJapanese">
          <div class="item">
            <div class="ari_font">
              {{ $t('account.financialInstitution') }}：
            </div>
            <input
              v-model="bank.area"
              class="card"
              type="text"
              :placeholder="$t('account.financialInstitution')"
            >
          </div>
          <div class="item">
            <div class="ari_font">
              {{ $t('account.recipientName') }}：
            </div>
            <input
              v-model="bank.name"
              class="card"
              type="text"
              :placeholder="$t('account.recipientName')"
            >
          </div>
          <div class="item">
            <div class="ari_font">
              {{ $t('account.ordinaryAccountNumber') }}：
            </div>
            <input
              v-model="bank.account"
              class="card"
              type="text"
              :placeholder="$t('account.ordinaryAccountNumber')"
            >
          </div>
          <div class="item">
            <div class="ari_font">
              {{ $t('account.branchName') }}：
            </div>
            <input
              v-model="bank.branch_name"
              class="card"
              type="text"
              :placeholder="$t('account.branchName')"
            >
          </div>
          <div class="item">
            <div class="ari_font">
              {{ $t('account.branchCode') }}：
            </div>
            <input
              v-model="bank.branch_code"
              class="card"
              type="text"
              inputmode="numeric"
              :placeholder="$t('account.branchCode')"
            >
          </div>
        </template>
        <template v-else>
          <div class="item">
            <div class="ari_font">
              {{ $t('invest_bank.name') }}：
            </div>
            <input
              v-model="bank.name"
              class="card"
              type="text"
              :placeholder="$t('invest_bank.namein')"
            >
          </div>
          <div class="item">
            <div class="ari_font">
              {{ $t('invest_bank.account') }}：
            </div>
            <input
              v-model="bank.account"
              class="card"
              type="text"
              :placeholder="$t('invest_bank.accountin')"
            >
          </div>
          <div class="item">
            <div class="ari_font">
              {{ $t('invest_bank.bank') }}：
            </div>
            <input
              v-model="bank.area"
              class="card"
              type="text"
              :placeholder="$t('invest_bank.bankin')"
            >
          </div>
        </template>
      </div>
    </div>
    <div
      class="basic_btn"
      @click="submitBtn"
    >
      {{ $t('account.submit') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
  import Api from "../../interface/index";
  import {
        Overlay,Uploader,Button,DropdownMenu, DropdownItem,Toast
    } from 'vant';
    import axios from 'axios'

    Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
    export default {
        name: "AddcountUsdt",
        data() {
            return {
                bank: {
                    account: '',
          name:'',
                    area: '',
                    bank:'',
                    img:'',
                    type:0,
                    wid:0,
                    branch_name: '',
                    branch_code: ''
                },
        fileList: [],
        value: null,
        wallets:[],
        isSubmitting: false,
        defaultWalletMissing: false
            };
        },
        computed: {
          isJapanese() {
            return String(this.$i18n.locale || '').toLowerCase() === 'ja_jp';
          }
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
      start(){
        Fetch('/user/wallet_type',{
        }).then(r=>{
          const list = Array.isArray(r.data) ? r.data : [];
          this.wallets = [];
          for (let i = 0; i < list.length; i++) {
            this.wallets.push({
                text: list[i].name,
                value: i,
                type: Number(list[i].type),
                wid: Number(list[i].id)
            });
          }
          const defaultIndex = this.isJapanese
            ? this.wallets.findIndex(item => item.type === 4)
            : this.wallets.findIndex(item => item.type === 1 && String(item.text).trim().toUpperCase() === 'USDT(ERC-20)');
          if (defaultIndex < 0) {
            this.defaultWalletMissing = true;
            this.clearWalletFields();
            this.$notify(this.$t('account.defaultWalletUnavailable'));
            return;
          }
          this.selectWallet(defaultIndex, false);
        }).catch(() => {
          this.defaultWalletMissing = true;
        });
      },
            submitBtn(){
        if (this.isSubmitting) return;
        if (this.defaultWalletMissing || !this.bank.wid) {
            this.$notify(this.$t('account.defaultWalletUnavailable'));
            return;
        }
        if (this.bank.type === 4 && this.isJapanese) {
          if (!this.bank.area || !this.bank.name || !this.bank.account || !this.bank.branch_name || !this.bank.branch_code) {
            this.$notify(this.$t('account.bankDetailsIncomplete'));
            return;
          }
          if (!/^\d+$/.test(this.bank.branch_code)) {
            this.$notify(this.$t('account.branchCodeInvalid'));
            return;
          }
        } else if (!this.bank.account) {
            this.$notify(this.$t('account.addressEmpty'));
            return;
        }
         // 定义波场地址的正则表达式
      //   var tronAddressRegex = /^(T[1-9A-HJ-NP-Za-km-z]{33})$/;
      
      //     // 使用正则表达式测试输入的钱包地址
      //   if (!tronAddressRegex.test(this.bank.account)) {
      //     this.$notify(this.$t('shopd.trcaddrerr'));
      //     return;
      //   } 
        // if (!this.bank.img) {
        //     this.$notify(this.$t('account.qrcodeEmpty'));
        //     return;
        // }
                this.isSubmitting = true;
                Fetch('/user/bank_add',{
                    ...this.bank
                }).then(()=>{
                    this.$router.go(-1);
                }).catch(() => {}).then(() => {
                    this.isSubmitting = false;
                });
            },
      onOversize() {
          this.$toast(this.$t('account.within2megabytes'));
      },
      beforeRead(file) {
          if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
              this.$toast(this.$t('account.supportPicture'));
              return false;
          }
          return true;
      },
      afterRead(file) {
          let formData = new FormData();
        formData.append('language', this.$i18n.locale||"zh_cn");
          formData.append('file', file.file);
          formData.append('id', this.$router.history.current.params.id);
        formData.append('token', localStorage.getItem('token'));
        Toast.loading({
          forbidClick: true,
          duration: 20000
        });
          axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
          Toast.clear();
          if (r.data.code === 1) {
            this.bank.img = r.data.data;
              } else {
                  if (r.data.info) {
                      this.$toast(r.data.info);
                  } else {
                      this.$toast(this.$t('account.uploadFail'));
                  }
              }
          });
      },
      onChange(){
        this.selectWallet(Number(this.value), true);
      },
      selectWallet(index, resetFields) {
        const wallet = this.wallets[index];
        if (!wallet) return;
        if (resetFields) this.clearWalletFields();
        this.value = index;
        this.bank.bank = wallet.text;
        this.bank.type = wallet.type;
        this.bank.wid = wallet.wid;
        this.defaultWalletMissing = false;
      },
      clearWalletFields() {
        this.bank.account = '';
        this.bank.name = '';
        this.bank.area = '';
        this.bank.branch_name = '';
        this.bank.branch_code = '';
        this.bank.bank = '';
        this.bank.type = 0;
        this.bank.wid = 0;
      }
            
        }
    };
</script>

<style lang="less" scoped>
  // /deep/ .van-overlay{
  //   background-color:hsla(0,0%,100%,0);
  // }
 //    /deep/ .van-dropdown-menu {
 //        position: relative;
  //   width: 100%;
 //        z-index: 10;
 //        color: #CCCCCC;
 //    }

    /deep/ .van-dropdown-menu__bar {
    box-shadow:none;
        // position: relative;
        // z-index: 10;
        // height: 34px;
        // border: 1px solid #D9D9D9;
        // border-radius: 4px;
        // text-align: left;
    }
 //    /deep/ .van-dropdown-item--down {
 //        margin: 0 auto;
 //        z-index: 12;
 //        transform: translateX(4px);
 //    }

    // /deep/ .van-dropdown-menu__item {
    //     justify-content: flex-start;
    //     color: #ccc;
    //     background-color: #fff;
    // }

 //    /deep/ .van-dropdown-menu__title {
 //        width: 100%;
 //    }

 //    /deep/ .van-dropdown-menu__title::after {
 //        width: 13px;
 //        height: 22px;
 //        transform: none;
 //        background: url(../../assets/images/drop.png) no-repeat center center;
 //        background-size: 100% 100%;
 //        border: none;
 //        opacity: 1;
 //        margin-top: -11px;
 //        right: 10px;
 //    }

 //    /deep/ .van-cell {
 //        padding: 5px 8px;
 //    }

 //    /deep/ .van-cell__title {
 //        flex: 3;
 //        white-space: normal;
 //    }

 //    /deep/ .van-ellipsis {
 //        color: #000;
 //    }

 //    /deep/ .van-dropdown-item__option {
 //        color: #ccc;
 //        border: 1px solid #D9D9D9;
 //        border-bottom: none;
 //        border-radius: 4px;
 //    }

 //    /deep/ .van-dropdown-item__option:last-child {
 //        border-bottom: 1px solid #D9D9D9;
 //    }

 //    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
 //        color: #000;

 //        .van-dropdown-item__icon {
 //            color: #E96259;
 //        }
 //    }
  /deep/ .van-button--primary {
      background-color: transparent;
      border: none;
      width: 100%;
    height: 100%;
  }
  /deep/ .van-uploader__input-wrapper {
      width: 100%;
  }
  /deep/ .van-uploader__wrapper{
    width: 100%;
    height: 100%;
  }
  /deep/ .van-uploader__upload{
    width: 100%;
    height: 100%;
    margin:0;
  }
  /deep/ .van-uploader__preview{
    margin:0;
  }
  /deep/ .van-uploader__preview-image{
    width: 100%;
    height: 100%;
  }
  
    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
    margin: 10px;
        margin-top: 12px;
        .item {
            height: 50px;
            padding: 0 16px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }
      .card{
        width: 100%;
      }
            input {
                line-height: 14px;
            }
        }
    }

    .ari_font {
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .basic_btn {
        margin: 75px auto 0 auto;
    }
  .qrcode{
    padding-top: 30px;
    padding-bottom: 30px;
    text-align: center;
    div{
      color: #999;
      font-size: 14px;
      margin-bottom: 20px;
    }
    .upload{
      width: 100%;
      height: 100%;
    }
    .qrcode_img{
      width: 250px;
      height: 250px;
      margin: 0 auto;
      background: linear-gradient(to left, #999, #999) left top no-repeat, 
            linear-gradient(to bottom, #999, #999) left top no-repeat, 
            linear-gradient(to left, #999, #999) right top no-repeat,
            linear-gradient(to bottom, #999, #999) right top no-repeat, 
            linear-gradient(to left, #999, #999) left bottom no-repeat,
            linear-gradient(to bottom, #999, #999) left bottom no-repeat,
            linear-gradient(to left, #999, #999) right bottom no-repeat,
            linear-gradient(to left, #999, #999) right bottom no-repeat;
      background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
      span{
        line-height: 220px;
      }
      img{
        width: 240px;
        height: 240px;
        position: relative;
        top: -255px;
      }
    }
  }
  ::placeholder {
    color: #727d91 !important; /* 设置你想要的颜色 */
  }
  
  /deep/ .van-dropdown-menu__title::after {
      width: 8px;
      height: 8px;
      border-color: transparent transparent #727d91 #727d91;
    right: -18px;
    margin-top: -10px;
  }
  /deep/ .van-dropdown-menu__title--down::after {
    margin-top: -1px !important;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
  }
  /deep/ .van-dropdown-menu__bar{
    background-color: transparent;
  }
  /deep/ .van-dropdown-item--down{
    margin: 0 10px;
  }
  /deep/ .van-dropdown-item__option--active{
    color: #fff;
  }
  /deep/ .van-dropdown-item__option--active .van-dropdown-item__icon{
    color: #fff;
  }
  /deep/ .van-cell{
    background-color: #727d91;
  }

  .recharge_wrap {
    min-height: 100vh;
    padding-bottom: 88px;
    box-sizing: border-box;
    background: #f4f5fb;
    color: #061429;
    font-size: 12px;
  }

  .red_top_bg {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 50px;
    background: #f7f8fd;
  }

  .big_tit {
    height: 50px;
    color: #202637;
    font-size: 14px;
    font-weight: 500;
    line-height: 50px;
    text-align: center;
  }

  .back_left {
    position: absolute;
    left: 14px;
    top: 11px;
    width: 28px;
    height: 28px;
    background: none;
  }

  .back_left::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 7px;
    width: 10px;
    height: 10px;
    border-left: 2px solid #071426;
    border-bottom: 2px solid #071426;
    transform: rotate(45deg);
  }

  .wrap_box.warp1 {
    margin: 16px;
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
  }

  .warp1 .item {
    min-height: 56px;
    height: auto;
    padding: 0 14px;
    box-sizing: border-box;
    border-color: #f0f2f7;
    color: #061429;
    font-size: 12px;
  }

  .warp1 .item input {
    width: 100%;
    color: #061429;
    font-size: 14px;
    line-height: 22px;
  }

  .warp1 .item input::placeholder {
    color: #b6bdca;
    font-size: 12px;
  }

  .ari_font {
    min-width: 92px;
    height: auto;
    color: #061429;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }

  .card {
    min-width: 0;
    flex: 1;
  }

  /deep/ .van-dropdown-menu__bar {
    height: 48px;
    background: transparent;
    box-shadow: none;
  }

  /deep/ .van-dropdown-menu__title {
    color: #061429;
    font-size: 14px;
    line-height: 22px;
  }

  /deep/ .van-dropdown-menu__title::after {
    border-color: transparent transparent #9aa2b1 #9aa2b1;
  }

  /deep/ .van-dropdown-item--down {
    margin: 0 16px;
  }

  /deep/ .van-cell {
    background: #fff;
    color: #061429;
    font-size: 12px;
  }

  /deep/ .van-dropdown-item__option--active {
    color: #ff1724;
  }

  /deep/ .van-dropdown-item__option--active .van-dropdown-item__icon {
    color: #ff1724;
  }

  .qrcode {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .qrcode div {
    color: #8f97a6;
    font-size: 12px;
  }

  .qrcode .qrcode_img {
    width: 190px;
    height: 190px;
    background-color: #f7f8fd;
  }

  .qrcode .qrcode_img span {
    line-height: 178px;
  }

  .qrcode .qrcode_img img {
    width: 180px;
    height: 180px;
    top: -195px;
  }

  .basic_btn {
    width: calc(100% - 32px);
    height: 44px;
    margin: 22px auto 0;
    border-radius: 12px;
    background: linear-gradient(135deg, #ff4e58 0%, #ff1724 100%);
    box-shadow: 0 8px 18px rgba(255, 49, 63, .18);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 44px;
    text-align: center;
  }
</style>
